import axios from "axios";
import getStoredUser, { getStoredDeviceInfo } from "../helper/sessionHelper";

const devideInfo = getStoredDeviceInfo();
const user = getStoredUser();

const axiovishwam = axios.create({
  baseURL: process.env.REACT_APP_API_VISHWAM_BASE_URL,
  //timeout: 60000,
  headers: {
    //   //Authorization: `Bearer ${sessionStorage.getItem("session_accesstoken")}`,
    // "Content-Type": "application/json",
    // Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    InternalApiKey: "123",
    "X-User-UserId": user?.userId || 0,
    "X-User-UserName": user?.userName || "",
    "X-User-CompanyId": user?.companyId || 0,
    "X-IP-Address": devideInfo?.iPAddress || "",
    "X-Device-Info": devideInfo?.deviceInfo || "",
    "X-Is-Browser": devideInfo?.isMobile,
  },
  //timeout: 5000,
});

export default axiovishwam;
